import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fetchVisitorTypes, fetchIdProofTypes, fetchMeetingVenues, insertAppointment, fetchGateDetails, fetchBuildingsByGate } from '../../services/Api';
import Webcam from 'react-webcam'; // Import react-webcam
import { User } from 'react-feather'; // Import the User icon
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SelfieSegmentation } from '@mediapipe/selfie_segmentation';
import { FaceDetection } from '@mediapipe/face_detection';
import SignatureCanvas from 'react-signature-canvas';
import { axiosInstance } from "../../services/Api";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 18px 7px 33px;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Heading = styled.h1`
  font-size: 25px;
  font-family: 'Segoe UI', Semibold;
  color:#2B3497;
  margin: 0;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  width: 81px;
  height: 32px;
  border-radius: 7px;
  box-shadow: 0px 5px 10px #2b349754;
  color: white;
  font-size: 14px;
  border: none;
  cursor: pointer;
  font-family: 'Segoe UI', Semibold;
`;

const ResetButton = styled(Button)`
  background-color: red;
`;

const SubmitButton = styled(Button)`
  background-color: #2b3497;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 9px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Card = styled.div`
  flex: 1;
  background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  padding: 27px;
  opacity: 1;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-family: 'Segoe UI', Semibold;
  color: #000000;
  margin-bottom: 5px;
  font-weight:600;
`;

const Asterisk = styled.span`
  color: red;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px; /* Adjust spacing between inputs */
  justify-content: space-between;
  width: 100%;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;
const InputLabelN = styled.label`
  margin-bottom: 5px;
  display: block;
    font-weight:600;

`;

const StyledDatePicker = styled(DatePicker)`
  width: 335px;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    padding: 8px 0;
    border: none;
    font-family: 'Segoe UI', Regular;
    background: transparent;
    border-bottom: 1px solid #2b3497;
    &:focus {
      outline: none;
      border-bottom: 2px solid #2b3497;
    }
  }
     @media (max-width: 1920px) and (min-width: 1720px) {
       width: 545px;

  }
       @media (max-width: 1720px) and (min-width: 1420px) {
       width: 391px;

  }
         @media (max-width: 1420px) and (min-width: 1220px) {
       width: 260px;

  }
              @media (max-width: 1220px) and (min-width: 1020px) {
       width: 200px;

  }
`;

const ProfileCard = styled(Card)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Circle = styled.div`
  width: 131px;
  height: 131px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
`;

const ProfileIcon = styled.div`
  width: 134px;
  height: 131px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
  position: relative;
`;

const PlusIcon = styled.div`
  width: 47px;
  height: 23px;
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #BFBFBF;
  font-size: 44px;
  font-weight: 700;
`;

const ProfileText = styled.div`
  font-family: 'Segoe UI', Semibold;
  font-size: 18px;
  color: #ff3030;
  margin-bottom: 20px;
`;
const VisitorPhotoHeading = styled.div`
  font-family: 'Segoe UI', Semibold;
  font-size: 25px;
  font-weight:700;
  color:#2B3497;
  text-align: center;
  margin-bottom: 10px;
`;

const PhotoButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: #343d9b;
  box-shadow: 0px 10px 10px #2b349733;
  border: 2px solid #343d9b;
  border-radius: 8px;
  opacity: 1;
  color: #ffffff;
  cursor: pointer;
  margin-bottom: 20px;
`;

const ActionButton = styled.button`
  width: 160px;
  height: 35px;
  background-color: transparent;
  border: 2px solid #343d9b;
  border-radius: 8px;
  box-shadow: 0px 10px 10px #2b349733;
  opacity: 1;
  cursor: pointer;
  margin-bottom: 20px;
           @media (max-width: 1420px) and (min-width: 1220px) {
  width: 125px;

  }
              @media (max-width: 1220px) and (min-width: 1020px) {
  width: 100px;

  }
`;
const CheckboxRowContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 20px;
    flex-direction: column;
`;
const AdditionalInputContainerN = styled.div`
  margin-top: 16px;
    margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  color: red;
  font-family: 'Segoe UI', Semibold;
  font-size: 14px;
`;
const Checkbox = styled.input`
width: 20px;  /* Increases the size of the checkbox */
  height: 20px;
  margin-right: 8px;
`;
const CheckboxLabel = styled.span`
  font-weight: 400;
      color: #000;
    font-size: 16px;
  margin-right: 8px; /* Adds space between the label and checkbox */
`;
const CheckboxContainernew = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); /* Creates responsive grid */
  gap: 10px; /* Adds space between checkboxes */
  max-width:500px; /* Adjust the width as needed */
`;
const CheckboxLabelnew = styled.span`
display: inline-flex;
  align-items: center;  /* Ensures vertical alignment of the checkbox and text */
  gap: 8px;            /* Adds space between the checkbox and text */
  font-size: 14px;     /* Adjust based on your preferred font size */
  margin: 5px 0; 
  font-weight: 400;
      color: #000;

`;

const PrivacyLink = styled.a`
  color: #2b3497;
  margin-left: 5px;
  text-decoration: none;
  cursor:pointer;
`;
const WebcamContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
`;
const ButtonRow = styled.div`
  display: flex;
  gap: 10px; /* Adjust gap between buttons */
  margin-bottom: 20px; /* Optional: Adjust margin bottom */
`;

const Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
`;

const Tab = styled.button`
  background: none;
  border: none;
  font-family: 'Segoe UI', Semibold;
  padding: 10px 20px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: #000;
  &:hover {
    color: #2B3497;
  }
  ${({ active }) => active && `
    border-bottom: 2px solid #2B3497;
    color: #2B3497;
  `}
    ${({ disabled }) => disabled && `
  cursor:not-allowed;
  opacity: 0.5
  `}
`;

const TabContent = styled.div`
  display: ${({ active }) => (active ? 'block' : 'none')};
`;
const HeaderN = styled.h3`
  margin-top: 16px;

  color: ${(props) => (props.disabled ? '#a9a9a9' : '#2B3497')}; /* Change color if disabled */
`;

const DropdownContainer = styled.div`
  margin-top: 16px;
`;

const DropdownLabel = styled.label`
  font-weight:600;
  margin-right: 8px;
`;

const StyledDropdown = styled.select`
  padding: 10px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }

  option {
    padding: 8px;
  }
`;

const InputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  gap:14px
`;

const SpinnerInput = styled.input`
  padding: 10px;
  width: 60px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const SpinnerInputLabel = styled.label`
  font-weight:600;
`;


const RecurrenceInput = styled.input`
  padding: 10px;
  width: 80px;
  text-align: center;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #f9f9f9;
  cursor: pointer;
  margin-left: 8px;

  &:focus {
    border-color: #293495;
    outline: none;
  }
`;

const AdditionalInputContainer = styled.div`
  margin-top: 16px;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  align-items: flex-start;
`;
const SelectedValuesContainer = styled.div`
  margin-top: 10px;
  padding: 12px;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
`;

const SelectedHeader = styled.h4`
  margin-bottom: 11px;
  font-weight: bold;
  color: #293495;
`;


const ValueRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const SelectedValue = styled.div`
  font-weight: bold;
  color: #000;
`;


const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SwitchLabel = styled.label`
  font-weight:600;
  font-size: 16px;
`;

const Switch = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const SwitchText = styled.span`
  font-weight: bold;
  margin-left: 10px;
  color: ${({ isOn }) => (isOn ? '#28a745' : '#6c757d')}; // Green for Yes, Gray for No
`;

const SwitchSlider = styled.div`
  width: 50px;
  height: 24px;
  background-color: ${({ isOn }) => (isOn ? '#28a745' : '#ccc')}; // Green for Yes, Gray for No
  border-radius: 34px;
  position: relative;
  transition: 0.4s;

  &:before {
    content: '';
    position: absolute;
    height: 20px;
    width: 20px;
    left: ${({ isOn }) => (isOn ? '26px' : '4px')}; // Moves the slider based on the toggle state
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
  }
`;

const InputFieldContainer = styled.div`
  margin-top: 20px;
`;

const InputLabel = styled.label`
  font-weight:600;
  margin-bottom: 5px;
  display: block;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  resize: none;
  &:focus {
    border-color: #28a745; // Green border on focus
  }
`;
const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const PopupContent = styled.div`
  background: white;
  width: 500px;
  max-height: 80%;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  text-align: left;
   /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #293495; /* Custom scrollbar thumb color */
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ff3030; /* Hover color */
  }

  /* Firefox scrollbar */
  scrollbar-color: #293495 #f1f1f1;
  scrollbar-width: thin;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center; /* Center the button horizontally */
  margin-top: 20px;
`;

const CloseButton = styled.button`
  background-color: #293495;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #ff3030;
  }
`;

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
`;

const Chip = styled.div`
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 5px 10px;
  margin: 2px;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

const RemoveChipButton = styled.span`
  color: #ff0000;
  font-weight: bold;
  margin-left: 5px;
  cursor: pointer;
`;

const InputField = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  margin-left: 5px;
  padding: 5px;
`;

const SuggestionBox = styled.ul`
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 5px 0 0;
  padding: 0;
  list-style: none;
  background: white;
  max-height: 150px;
  overflow-y: auto;
`;

const SuggestionItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;
const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const CustomFileButton = styled.button`
  background-color: #293495;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  font-family: 'Segoe UI', Semibold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #1f2875;
  }
`;

const FileNameInput = styled.input`
  flex: 1;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  color: #000;

  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;

//css file acknowlaged
const AckItem = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 12px;
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #f0f4ff;
  }

  input {
    margin-top: 3px;
    cursor: pointer;
  }
`;

const AckText = styled.span`
  font-size: 14px;
  color: #333;
  line-height: 1.4;

  a {
    color: #293495;
    font-weight: 500;
    text-decoration: underline;
  }
`;


const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  overflow-x: auto; /* makes it scrollable horizontally */
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(
    to right,
    #e6e6e6,
    #f2f2f2,
    #f5f5f5,
    #f3f3f3,
    #e9e9e9
  );
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 9px 10px;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
  font-size: 13px;
`;

const PdfModalOverlay = styled.div`
  position: fixed;
  top: 0; 
  left: 0;
  width: 100%; 
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const PdfModalContent = styled.div`
  background: #fff;
  padding: 20px;
  width: 80%;
  max-width: 900px;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #0000001a;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const CloseButtonIcon = styled.button`
  position: absolute;
  top: 4px; 
  right: 15px;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  color: #293495;
`;

const PdfFrame = styled.iframe`
  width: 100%;
  height: 80vh;
  border: none;
  margin-top: 10px;
`;

const AgreeButton = styled.button`
  margin-top: 15px;
  align-self: flex-end;
  padding: 10px 18px;
  background: #293495;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;

  &:hover {
    background: #1f276f;
  }
`;



const GroupAppoinmentFormPage = () => {
    const location = useLocation();
    const { checkType } = location.state || {};
    const { GroupType } = location.state || {};
    const navigate = useNavigate(); // Initialize useNavigate hook
    const [selectedGate, setSelectedGate] = useState('');
    const [selectedVisitorType, setSelectedVisitorType] = useState('');
    const [selectedIdProofType, setSelectedIdProofType] = useState('');

    const [visitorTypes, setVisitorTypes] = useState([]);
    const [idProofTypes, setIdProofTypes] = useState([]);

    const [meetingvenues, setMeetingvenues] = useState([]);
    const [gates, setGates] = useState([]);
    const [buildings, setBuildings] = useState([]);
    const [activeTab, setActiveTab] = useState('details'); // State for tab management

    const [isChecked, setIsChecked] = useState(false);
    const [recurrencePattern, setRecurrencePattern] = useState('');
    const [selectedrecurrencePattern, setSelectedrecurrencePattern] = useState('');
    const [recurrencePatternAPI, setRecurrencePatternAPI] = useState('');
    const [selectedDay, setSelectedDay] = useState('');
    const [selectedWeekday, setSelectedWeekday] = useState([]); // Properly initialized as an empty array
    const [selectedWeekdayAPI, setSelectedWeekdayAPI] = useState('');
    const [validTill, setvalidTill] = useState('');

    const [selectedMonth, setSelectedMonth] = useState([]); // Initialize as an empty array
    const [selectedMonthAPI, setSelectedMonthAPI] = useState('');

    const [disabled, setDisabled] = useState(true); // Initialize disabled state

    const [isAllDayChecked, setIsAllDayChecked] = useState(false);
    const [recurEvery, setRecurEvery] = useState();

    const [showSignatureModal, setShowSignatureModal] = useState(false);
    const sigCanvasRef = useRef(null);


    const [isAssistanceRequired, setIsAssistanceRequired] = useState(false);
    const [isServiceProviderAccess, setIsServiceProviderAccess] = useState(false);
    const [isWiFiRequired, setIsWiFiRequired] = useState(false);
    const [isEscortRequired, setIsEscortRequired] = useState(false);
    const [isadditionalNotify, setIsAdditionalNotify] = useState(false);

    const [additionalMessage, setAdditionalMessage] = useState('');
    const [checkInInstructions, setCheckInInstructions] = useState('');

    const toggleAssistanceRequired = () => setIsAssistanceRequired(!isAssistanceRequired);
    const toggleServiceProviderAccess = () => setIsServiceProviderAccess(!isServiceProviderAccess);
    const toggleWiFiRequired = () => setIsWiFiRequired(!isWiFiRequired);
    const toggleEscortRequired = () => setIsEscortRequired(!isEscortRequired);
    const toggleadditionalNotifyRequired = () => setIsAdditionalNotify(!isadditionalNotify);

    const handleAdditionalMessageChange = (e) => setAdditionalMessage(e.target.value);
    const handleCheckInInstructionsChange = (e) => setCheckInInstructions(e.target.value);



    const handleCheckboxChange = () => {
        setIsChecked((prev) => !prev);
    };
    const handleDropdownChange = (event) => {
        console.log("event.target", event.target);
        const selectedText = event.target.options[event.target.selectedIndex].text;
        console.log("selectedText", selectedText);
        // This gets the text of the selected option

        setRecurrencePattern(event.target.value);
        if (event.target.value == '1') {
            setRecurrencePatternAPI(1);
        }
        if (event.target.value == '2') {
            setRecurrencePatternAPI(2);
        }
        if (event.target.value == '3') {
            setRecurrencePatternAPI(3);
        }

    };
    const handleDayChange = (event) => {
        setSelectedDay(event.target.value);
    };
    const handleWeekdayCheckboxChange = (weekday) => {
        setSelectedWeekday((prevSelectedWeekdays) => {
            // Convert the string "1,5" into an array
            let selectedDaysArray = prevSelectedWeekdays ? prevSelectedWeekdays.split(',').map(Number) : [];

            if (selectedDaysArray.includes(weekday)) {
                // If the day is already selected, remove it
                selectedDaysArray = selectedDaysArray.filter((day) => day !== weekday);
            } else {
                // Otherwise, add the new selected weekday
                selectedDaysArray.push(weekday);
            }

            // Convert back to a comma-separated string and return
            return selectedDaysArray.join(',');
        });
        console.log("selected week day", selectedWeekday);

    };
    const handleMonthCheckboxChange = (month) => {
        setSelectedMonth((prevSelectedMonths) => {
            // Convert the comma-separated string "1,3,5" into an array of numbers
            let selectedMonthsArray = prevSelectedMonths ? prevSelectedMonths.split(',').map(Number) : [];

            if (selectedMonthsArray.includes(month)) {
                // If the month is already selected, remove it
                selectedMonthsArray = selectedMonthsArray.filter((m) => m !== month);
            } else {
                // Otherwise, add the new selected month
                selectedMonthsArray.push(month);
            }

            // Convert back to a comma-separated string and return
            return selectedMonthsArray.join(',');
        });
    };
    const handleAllDayCheckboxChange = () => {
        setIsAllDayChecked((prev) => !prev);
    };

    const handleRecurEveryChange = (event) => {
        setRecurEvery(event.target.value);
    };

    const getRecurrencePatternAPIValue = () => {
        switch (recurrencePattern) {
            case '1':
                return 1;
            case '2':
                return 2;
            case '3':
                return 3;
            default:
                return null; // Handle default case as needed
        }
    };


    // Generate an array for days 1 to 31
    const days = Array.from({ length: 31 }, (_, i) => i + 1);



    useEffect(() => {
        const getVisitorTypes = async () => {
            const storedEmpId = localStorage.getItem("employeeId");
            try {
                const types = await axios.get(`/VisitorType/GetVisitorTypeDetailsByEmpId/${storedEmpId}`);
                setVisitorTypes(types.data);
            } catch (error) {
                console.error('Error fetching visitor types:', error);
            }
        };
        const getIdProofTypes = async () => {
            try {
                const types = await fetchIdProofTypes();
                setIdProofTypes(types);
            } catch (error) {
                console.error('Error fetching visitor types:', error);
            }
        };
        const getMeetingvenues = async () => {
            try {
                const venues = await fetchMeetingVenues();
                setMeetingvenues(venues);
            } catch (error) {
                console.error('Error fetching meeting venues:', error);
            }
        };
        const getGateDetails = async () => {
            try {
                const venues = await fetchGateDetails();
                setGates(venues);
            } catch (error) {
                console.error('Error fetching Gate venues:', error);
            }
        };
        const fetchAppointmentDataeemp = async () => {
            try {
                const responseeEMP = await axios.get('/Employee/')
                // console.log("response", responseeEMP);
                // console.log('Employee Data:', responseeEMP.data);
                setEmployeeData(responseeEMP.data);
            } catch (error) {
                console.error('Error fetching appointment data:', error);
            }
        };
        fetchAppointmentDataeemp()
        getVisitorTypes();
        getIdProofTypes();
        getMeetingvenues();
        getGateDetails();
    }, []);
    const { data } = location.state || {}; // Destructure
    console.log("data", data);
    const [fieldData, setFieldData] = useState('');




    useEffect(() => {


        if (data) {


            setFormData({
                firstName: data.firstName || '',
                middleName: data.middleName || '',
                lastName: data.lastName || '',
                gender: data.gender,
                nationality: data.nationality,
                // groupLeaderName: data?.groupLeaderName || '',
                visitorEmail: data?.visitorEmail || '',
                visitorMobile: data?.visitorMobile || '',
                meetingVenue: data?.meetingVenue || '',
                company: data?.visitorCompany || '',
                meetingFrom: data?.appointmentDate || '',
                meetingTo: data?.validTill || '',
                selectedVisitorTypeId: data?.selectedVisitorTypeId || '',
                selectedIdProofTypeId: data?.idProofType || '',
                idProofNo: data?.idProofNo || '',
                gate: data?.gate || '',
                visitorPhoto: data.photo,// Bind empId to hostName
                building: data?.building || '',
                visitorPhoto: data?.photo || '',
                purpose: data.purpose || '',
                CardNumber: '',
                vehicleno: data.vehicleNo || '',

            })
            setProfileImage(`data:image/png;base64,${data.photo}`);

        }
        //  console.log("data.selectedRecurrence ", data.selectedRecurrence);

        if (data.recurrancePattern === 1) {
            setSelectedDay(data.selectedRecurrence);
        }
        if (data.recurrancePattern === 2) {
            if (data.recurrancePattern === 2) {

                // Directly use the selectedRecurrence string as the state value
                const weekdaysArray = data.selectedRecurrence
                    ? data.selectedRecurrence.split(',').map(Number)
                    : [];
                setSelectedWeekday(weekdaysArray);
            } else {
                setSelectedWeekday(''); // Reset the state when pattern is not 2
            }
        } else {
            setSelectedWeekday([]); // Reset if not in recurrence pattern 2
        }
        if (recurrencePattern === '3') {
            if (data.recurrancePattern === 3) {
                // Directly use the selectedRecurrence string as the state value
                const monthsArray = data.selectedRecurrence
                    ? data.selectedRecurrence.split(',').map(Number)
                    : [];
                setSelectedMonth(monthsArray); // Set an empty string if no data
            } else {
                setSelectedMonth([]); // Reset the state when pattern is not 2
            }
        }

        setIsChecked(data.repeatVisit);
        setRecurrencePattern(data.recurrancePattern === null ? null : data.recurrancePattern === 1 ? "1" : data.recurrancePattern === 2 ? "2" : "3"); // Set to default value (1 for Daily)
        setRecurEvery(data.recurEvery);
        setIsAllDayChecked(data.allDay);
        setIsAssistanceRequired(data.assitanceRequired);
        setIsServiceProviderAccess(data.serviceProviderAccess);
        setIsWiFiRequired(data.wifiRequired);
        setIsEscortRequired(data.escort);
        setIsAdditionalNotify(data.additionalNotification)
        setAdditionalMessage(data.messageToVisitor);
        setCheckInInstructions(data.checkinInstruction);
        if (data.notifyTo) {
            setSelectedEmails(data.notifyTo.split(",").map((email) => email.trim()));
        }
    }, [data]);

    useEffect(() => {
        const prepopulateGateAndBuilding = async () => {
            if (!data || meetingvenues.length === 0) {
                // console.log("Skipping: No data or empty meetingvenues");
                return;
            }

            const { gateId, buildingId, gate, building, meetingVenue } = data;
            // console.log(" API Data:", data);

            try {
                // Match meetingVenue
                const venueName = (meetingVenue || "").trim().toLowerCase();
                const matchedVenue = meetingvenues.find(
                    (v) => (v.locationName || "").trim().toLowerCase() === venueName
                );

                if (!matchedVenue) {
                    console.warn("No matching venue found for:", meetingVenue);
                    console.warn(" Available venues:", meetingvenues.map(v => v.locationName));
                    return;
                }
                //   console.log(" Matched Venue:", matchedVenue);

                // 2Fetch gates
                const { data: fetchedGates = [] } = await axios.get(
                    `/Location/GetGatesByLocationID?locationID=${matchedVenue.id}`
                );
                setGates(fetchedGates);
                // console.log(" Gates fetched:", fetchedGates);

                let selectedGateObject = null;
                if (gateId) {
                    selectedGateObject = fetchedGates.find((g) => g.id === gateId) || null;
                }
                if (!selectedGateObject && gate) {
                    selectedGateObject = fetchedGates.find(
                        (g) => g.name.trim().toLowerCase() === gate.trim().toLowerCase()
                    ) || null;
                }
                //console.log(" Selected Gate:", selectedGateObject);
                setSelectedGate(selectedGateObject);

                //  Fetch buildings if gate found
                // if (selectedGateObject?.id) {
                    // const { data: fetchedBuildings = [] } = await axios.get(
                    //     `/Location/GetBuidingsByGateID?gateID=${selectedGateObject.id}`
                    // );
                    const buildingsResponse = await axiosInstance.get(
                        `/Location/GetBuildingAndGateByLocationId/${matchedVenue.id}`,
                    );
                    const fetchedBuildings = buildingsResponse.data?.data?.buildings || [];
                    setBuildings(fetchedBuildings);
                    //console.log(" Buildings fetched:", fetchedBuildings);

                    let matchedBuilding = null;
                    if (buildingId) {
                        matchedBuilding = fetchedBuildings.find((b) => b.id === buildingId) || null;
                    }
                    if (!matchedBuilding && building) {
                        matchedBuilding = fetchedBuildings.find(
                            (b) => b.name.trim().toLowerCase() === building.trim().toLowerCase()
                        ) || null;
                    }
                    // console.log(" Selected Building:", matchedBuilding);

                    //  Update formData with IDs
                    setFormData((prev) => ({
                        ...prev,
                        gate: selectedGateObject?.id || "",
                        building: matchedBuilding?.id || ""
                    }));
                // }
            } catch (err) {
                console.error(" Error prepopulating:", err);
            }
        };

        prepopulateGateAndBuilding();
    }, [data, meetingvenues]);





    useEffect(() => {
        if (data && visitorTypes.length > 0) {
            const visitorTy = visitorTypes.find(
                (type) => type.id === data.selectedVisitorTypeId
            );
            //  console.log("visitorTy", visitorTy);

            if (visitorTy?.groupAppointmentInputField?.length > 0) {
                setFieldData(visitorTy.groupAppointmentInputField[0]);
                //   console.log("fieldData", visitorTy.groupAppointmentInputField[0]);
            }
        }
    }, [data, visitorTypes]);


    const [inputValue, setInputValue] = useState("");
    const [selectedEmails, setSelectedEmails] = useState([]);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    const handleInputChangeE = (e) => {
        const value = e.target.value;
        if (value == 'no') {
            setInputValue('')
        } else {
            setInputValue(value);

        }
    };

    const handleChipRemove = (email) => {
        if (isadditionalNotify) {
            setSelectedEmails((prev) => prev.filter((e) => e !== email));
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && inputValue && !selectedEmails.includes(inputValue)) {
            setSelectedEmails((prev) => [...prev, inputValue.trim()]);
            setInputValue("");
        }
    };
    // useEffect(() => {
    //     // Log the selected emails to the console whenever they update
    //     console.log("Selected Emails:", selectedEmails);

    // }, [selectedEmails]);


    useEffect(() => {
        if (selectedGate) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                gate: selectedGate.name, // Use the gate name in the form data
            }));
        }

    }, [selectedGate]);
    const [employeeData, setEmployeeData] = useState([]); // To store the employee data

    const handleGateChange = async (event) => {
        const gateID = parseInt(event.target.value, 10); // Convert to integer if gate.id is a number
        const selectedGateObject = gates.find(gate => gate.id === gateID);

        setSelectedGate(selectedGateObject); // Store the entire gate object
        setFormData(prev => ({
            ...prev,
            gate: selectedGateObject.id,
        }));


        // try {
        //     const buildings = await fetchBuildingsByGate(gateID);
        //     setBuildings(buildings);
        // } catch (error) {
        //     console.error('Error fetching buildings:', error);
        // }
    };



    const [formData, setFormData] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        gender: '',
        nationality: '',
        // groupLeaderName: '',
        visitorEmail: '',
        visitorMobile: '',
        company: '',
        meetingFrom: '',
        meetingTo: '',
        selectedVisitorTypeId: selectedVisitorType,
        selectedIdProofTypeId: selectedIdProofType,
        idProofNo: '',
        gate: '',
        building: '',
        visitorPhoto: '',
        assets: '',
        remarks: '',
        purpose: '',
        CardNumber: '',
        vehicleno: ''


    });

    const [formErrors, setFormErrors] = useState({
        firstName: false,
        // middleName: false,
        lastName: false,
        // groupLeaderName: false,
        visitorEmail: false,
        visitorMobile: false,
    });

    const handleResetAcknowledgement = () => {
        setAckChecklist(prev =>
            Object.fromEntries(
                Object.keys(prev).map(key => [key, false])
            )
        );
        setNdaDocumentFileName("");
        setNdaDocument("")
    }

    const handleReset = () => {
        setIsCheckedB(false)
        setIsCheckedP(false)
        setIsCheckedC(false)
        setFormData((prevFormData) => ({
            ...prevFormData, // Spread the existing state to retain other fields
            CardNumber: '',
            vehicleno: '',
            assets: '',
            remarks: ''
        }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        // Clear error when user starts typing
        if (formErrors[name]) {
            setFormErrors({
                ...formErrors,
                [name]: false,
            });
        }
    };
    const [transportVendorFileName, setTransportVendorFileName] = useState("");
    const [transportVendorFileBase64, setTransportVendorFileBase64] = useState("");


    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                resolve(null);
                return;
            }

            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]); // remove "data:...base64,"
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    const handleNext = async (event) => {
        event.preventDefault();
        let valid = true;
        const errors = {};

        if (!data?.entityId) {
            toast.error("Entity ID is missing");
            return;
        }
        if (fieldData.visitorNameField && formData.firstName === '') {
            errors.firstName = true;
            valid = false;
        }
        if (fieldData.visitorNameField && formData.lastName === '') {
            errors.lastName = true;
            valid = false;
        }
        if (fieldData.visitorEmailField && formData.visitorEmail === '') {
            errors.visitorEmail = true;
            valid = false;
        }
        if (fieldData.genderField && formData.gender === '') {
            errors.gender = true;
            valid = false;
        }
        if (fieldData.nationalityField && formData.nationality === '') {
            errors.nationality = true;
            valid = false;
        }
        if (fieldData.visitorMobileField && formData.visitorMobile === '') {
            errors.visitorMobile = true;
            valid = false;
        }
        // if (fieldData.visitorCompanyField && formData.company === '') {
        //   errors.company = true;
        //   valid = false;
        // }
        if (formData.selectedVisitorTypeId === '') {
            errors.selectedVisitorTypeId = true;
            valid = false;
        }
        if (fieldData.purpose && formData.purpose === '') {
            errors.purpose = true;
            valid = false;
        }
        if (fieldData.meetingOnField && formData.meetingFrom === null) {
            errors.meetingFrom = true;
            valid = false;
        }
        if (fieldData.meetingToField && formData.meetingTo === null) {
            errors.meetingTo = true;
            valid = false;
        }
        if (fieldData.locationField && formData.meetingVenue === '') {
            errors.meetingVenue = true;
            valid = false;
        }
        if (fieldData.gateField && formData.gate === '') {
            errors.gate = true;
            valid = false;
        }
        if (fieldData.areaField && formData.building === '') {
            errors.building = true;
            valid = false;
        }
        if (fieldData.idProofTypeField && formData.selectedIdProofTypeId === '') {
            errors.selectedIdProofTypeId = true;
            valid = false;
        }
        if (fieldData.idProofNumberField && formData.idProofNo === '') {
            errors.idProofNo = true;
            valid = false;
        }

        if (formData.visitorEmail !== '') {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(formData.visitorEmail)) {
                errors.visitorEmail = true;
                valid = false;
            }
        }

        if (fieldData.visitorMobileField && formData.visitorMobile === null) {
            errors.visitorMobile = true;
            valid = false;

        }

        // if (formData.visitorMobile !== '') {
        //     const mobilePattern = /^\d{10}$/;
        //     if (!mobilePattern.test(formData.visitorMobile)) {
        //         errors.visitorMobile = true;
        //         valid = false;
        //     }
        // }
        if (isCheckedB) {
            if (!formData.assets) {
                errors.assets = 'Please fill the asset name';
                valid = false;
                toast.error(
                    "Please fill the assets field"
                )
            }
        }
        if (isCheckedB) {
            if (!formData.remarks) {
                errors.assets = 'Please fill the asset name';
                valid = false;
                toast.error(
                    "Please fill the remark field"
                )
            }
        }


        if (!valid) {
            setActiveTab('details')
            setFormErrors(errors);
            console.log('Form has errors:', errors);
        } else if (isCheckedP && isCheckedC) {
            if (formData.visitorPhoto == '') {
                toast.error(
                    "photo is not captured, Please upload the photo "
                )
                return
            } else {
                setDetailsValid(true);
                setActiveTab("acknowledge")
            }
        } else {
            setActiveTab('details')
            toast.error('Please verify the privacy and covid fitness')
        }

    }


    const messages = {
        training: "Please agree to the Training Video acknowledgment.",
        safetyVideo: "Please agree to the Safety Video acknowledgment.",
        safetyDoc: "Please agree to the Safety Document acknowledgment.",
        ndaDoc: "Please agree to the NDA Document.",
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let valid = true;
        const errors = {};
        if (!data?.entityId) {
            toast.error("Entity ID is missing");
            return;
        }
        if (fieldData.visitorNameField && formData.firstName === '') {
            errors.firstName = true;
            valid = false;
        }
        if (fieldData.visitorNameField && formData.lastName === '') {
            errors.lastName = true;
            valid = false;
        }
        if (fieldData.visitorEmailField && formData.visitorEmail === '') {
            errors.visitorEmail = true;
            valid = false;
        }
        if (fieldData.genderField && formData.gender === '') {
            errors.gender = true;
            valid = false;
        }
        if (fieldData.nationalityField && formData.nationality === '') {
            errors.nationality = true;
            valid = false;
        }
        if (fieldData.visitorMobileField && formData.visitorMobile === '') {
            errors.visitorMobile = true;
            valid = false;
        }
        // if (fieldData.visitorCompanyField && formData.company === '') {
        //   errors.company = true;
        //   valid = false;
        // }
        if (formData.selectedVisitorTypeId === '') {
            errors.selectedVisitorTypeId = true;
            valid = false;
        }
        if (fieldData.purpose && formData.purpose === '') {
            errors.purpose = true;
            valid = false;
        }
        if (fieldData.meetingOnField && formData.meetingFrom === null) {
            errors.meetingFrom = true;
            valid = false;
        }
        if (fieldData.meetingToField && formData.meetingTo === null) {
            errors.meetingTo = true;
            valid = false;
        }
        if (fieldData.locationField && formData.meetingVenue === '') {
            errors.meetingVenue = true;
            valid = false;
        }
        if (fieldData.gateField && formData.gate === '') {
            errors.gate = true;
            valid = false;
        }
        if (fieldData.areaField && formData.building === '') {
            errors.building = true;
            valid = false;
        }
        if (fieldData.idProofTypeField && formData.selectedIdProofTypeId === '') {
            errors.selectedIdProofTypeId = true;
            valid = false;
        }
        if (fieldData.idProofNumberField && formData.idProofNo === '') {
            errors.idProofNo = true;
            valid = false;
        }

        if (formData.visitorEmail !== '') {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(formData.visitorEmail)) {
                errors.visitorEmail = true;
                valid = false;
            }
        }

        if (fieldData.visitorMobileField && formData.visitorMobile === null) {
            errors.visitorMobile = true;
            valid = false;

        }

        // if (formData.visitorMobile !== '') {
        //     const mobilePattern = /^\d{10}$/;
        //     if (!mobilePattern.test(formData.visitorMobile)) {
        //         errors.visitorMobile = true;
        //         valid = false;
        //     }
        // }
        if (isCheckedB) {
            if (!formData.assets) {
                errors.assets = 'Please fill the asset name';
                valid = false;
                toast.error(
                    "Please fill the assets field"
                )
            }
        }
        if (isCheckedB) {
            if (!formData.remarks) {
                errors.assets = 'Please fill the asset name';
                valid = false;
                toast.error(
                    "Please fill the remark field"
                )
            }
        }


        for (const key in ackChecklist) {
            console.log("key value", key)
            if (ackChecklist[key] === false) {
                setActiveTab("acknowledge");
                toast.error(messages[key]);
                return;
            }
        }

        if (!valid) {
            setActiveTab('details')
            setFormErrors(errors);
            console.log('Form has errors:', errors);
        } else if (isCheckedP && isCheckedC) {
            if (formData.visitorPhoto == '') {
                toast.error(
                    "photo is not captured, Please upload the photo "
                )
                return
            } else {

                const fetchHostDetails = async () => {
                    try {

                        let recurrencePattern = getRecurrencePatternAPIValue();

                        let newSelectedRecurrencePattern = '';

                        // Determine the selected recurrence pattern based on the recurrencePatternAPI value
                        if (recurrencePattern === 1) {
                            newSelectedRecurrencePattern = "";
                        } else if (recurrencePattern === 2) {
                            newSelectedRecurrencePattern = selectedWeekday;
                        } else if (recurrencePattern === 3) {
                            newSelectedRecurrencePattern = selectedMonth;
                        }

                        // Log the new selected recurrence pattern before setting the state
                        console.log("Selected Recurrence Pattern before update:", newSelectedRecurrencePattern);

                        const formattedEmails = selectedEmails.join(', ');
                        console.log("Submitting Emails:", formattedEmails);
                        const formDataAdditional = {
                            repeatVisit: isChecked,
                            recurrencePattern: recurrencePattern,
                            selectedRecurrence: String(newSelectedRecurrencePattern),
                            selectedDay: selectedDay,
                            selectedWeekday: selectedWeekdayAPI,
                            selectedMonth: selectedMonthAPI,
                            recurEvery: recurEvery,
                            isAllDay: isAllDayChecked,
                            assistanceRequired: isAssistanceRequired,
                            serviceProviderAccess: isServiceProviderAccess,
                            wifiRequired: isWiFiRequired,
                            escortRequired: isEscortRequired,
                            additionalNotification: isadditionalNotify,
                            notifyTo: formattedEmails,
                            additionalMessage: additionalMessage,
                            checkInInstructions: checkInInstructions,
                            CardNumber: formData.CardNumber || '0',
                            uploadDocument: transportVendorFileBase64,
                            NdaDocument: ndaDocumnet,

                        };

                        // Log the object to the console
                        console.log('Form Data formDataAdditional:', formDataAdditional);

                        const responseGroupCheckin = await axios.get(`/GroupMember/${data.id}`);
                        console.log("responseGroupCheckin", responseGroupCheckin);
                        const memberDetails = responseGroupCheckin.data
                        const AppId = data.id
                        navigate('/layout/group-member-page', { state: { formData, memberDetails, checkType, formDataAdditional, isCheckedB, isCheckedP, GroupType, AppId } });

                    } catch (error) {
                        console.error('Error fetching appointment details:', error);
                        // Handle error scenarios
                    }
                };
                fetchHostDetails();
            }
        } else {
            setActiveTab('details')
            toast.error('Please verify the privacy and covid fitness')
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: false,
        }));
    };


    const webcamRef = useRef(null);
    const [isCameraOn, setIsCameraOn] = useState(false);
    const [buttonLabel, setButtonLabel] = useState('Take photo');
    const [profileImage, setProfileImage] = useState(null);


    const handleCapture = async () => {
        if (!isCameraOn) {
            // Turn on the camera
            setIsCameraOn(true);
            setButtonLabel("Capture");
        } else {
            // Capture the webcam image
            const imageSrc = webcamRef.current.getScreenshot();
            console.log("Captured Image:", imageSrc);

            if (imageSrc) {
                // Create an image element from the captured image
                const img = new Image();
                img.src = imageSrc;

                img.onload = async () => {
                    // Create a canvas for image processing
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");

                    // Draw the captured image on the canvas
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    const faceDetection = new FaceDetection({
                        locateFile: (file) =>
                            `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
                    });

                    faceDetection.setOptions({
                        model: 'short', // fast + accurate model
                        minDetectionConfidence: 0.5,
                    });

                    await faceDetection.initialize();

                    // Run face detection
                    const detectionResults = await new Promise((resolve) => {
                        faceDetection.onResults(resolve);
                        faceDetection.send({ image: img });
                    });

                    // Check if face is detected
                    if (!detectionResults.detections || detectionResults.detections.length === 0) {
                        toast.error("Human face not detected");
                        return;
                    }


                    // Initialize MediaPipe Selfie Segmentation
                    const segmentation = new SelfieSegmentation({
                        locateFile: (file) =>
                            `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
                    });

                    segmentation.setOptions({
                        modelSelection: 1, // General-purpose face segmentation model
                    });

                    // Perform segmentation
                    await segmentation.initialize();
                    const results = await new Promise((resolve) => {
                        segmentation.onResults(resolve);
                        segmentation.send({ image: img });
                    });

                    // Create a canvas for output
                    const outputCanvas = document.createElement("canvas");
                    outputCanvas.width = img.width;
                    outputCanvas.height = img.height;
                    const outputCtx = outputCanvas.getContext("2d");

                    // Draw the original image
                    outputCtx.drawImage(img, 0, 0, img.width, img.height);

                    // Apply the segmentation mask
                    outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
                    outputCtx.drawImage(
                        results.segmentationMask,
                        0,
                        0,
                        img.width,
                        img.height
                    );

                    // Reset the operation and apply a transparent background
                    outputCtx.globalCompositeOperation = "destination-over";
                    outputCtx.fillStyle = "transparent"; // Transparent background
                    outputCtx.fillRect(0, 0, img.width, img.height);

                    // Convert the processed image to Base64
                    const base64Image = outputCanvas.toDataURL("image/png");

                    // Set the profile image and form data
                    setProfileImage(base64Image); // Display the processed image
                    setFormData((prevData) => ({
                        ...prevData,
                        visitorPhoto: base64Image.split(",")[1], // Store Base64 (excluding metadata)
                    }));

                    console.log("Processed Image (Base64):", base64Image);
                };
            }

            // Turn off the camera and reset the button label
            setIsCameraOn(false);
            setButtonLabel("Take photo");
        }
    };


    // Function to handle image upload from the file input
    const handleImageUpload = async (e) => {
        const file = e.target.files[0]; // Get the uploaded file
        if (!file || (file.type !== 'image/png' && file.type !== 'image/jpeg')) {
            toast.error('Please upload a PNG or JPEG image');
            return;
        }

        const reader = new FileReader();
        reader.onloadend = async () => {
            const img = new Image();
            img.src = reader.result;

            img.onload = async () => {
                // Create a canvas for image processing
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");

                // Draw the uploaded image on the canvas
                ctx.drawImage(img, 0, 0, img.width, img.height);

                // Initialize MediaPipe Selfie Segmentation
                const segmentation = new SelfieSegmentation({
                    locateFile: (file) =>
                        `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
                });

                segmentation.setOptions({
                    modelSelection: 1, // General-purpose face segmentation model
                });

                // Perform segmentation
                await segmentation.initialize();
                const results = await new Promise((resolve) => {
                    segmentation.onResults(resolve);
                    segmentation.send({ image: img });
                });

                // Create a canvas for output
                const outputCanvas = document.createElement("canvas");
                outputCanvas.width = img.width;
                outputCanvas.height = img.height;
                const outputCtx = outputCanvas.getContext("2d");

                // Draw the original image
                outputCtx.drawImage(img, 0, 0, img.width, img.height);

                // Apply the segmentation mask
                outputCtx.globalCompositeOperation = "destination-in"; // Retain only the face
                outputCtx.drawImage(
                    results.segmentationMask,
                    0,
                    0,
                    img.width,
                    img.height
                );

                // Reset the operation and apply a transparent background
                outputCtx.globalCompositeOperation = "destination-over";
                outputCtx.fillStyle = "transparent"; // Transparent background
                outputCtx.fillRect(0, 0, img.width, img.height);

                // Convert the processed image to Base64
                const base64Image = outputCanvas.toDataURL("image/png");

                // Update the processed image in state and form data
                setProfileImage(base64Image); // Display the processed image
                setFormData({ ...formData, visitorPhoto: base64Image.split(",")[1] });
                console.log("base64Image", base64Image.split(",")[1]);
                // Save Base64 (excluding metadata)
            };
        };

        reader.readAsDataURL(file); // Read the file as base64
    };
    const [isPopupVisiblePrivacy, setPopupVisiblePrivacy] = useState(false);
    const [isPopupVisibleCovid, setPopupVisibleCovid,] = useState(false);
    const [isCheckedB, setIsCheckedB] = useState(false);
    const [isCheckedP, setIsCheckedP] = useState(false);
    const [isCheckedC, setIsCheckedC] = useState(false); // Add state to track checkbox
    // Add state to track checkbox
    // Add state to track checkbox



    const handlePrivacyLinkClickPrivacy = () => {
        setPopupVisiblePrivacy(true);
    };

    const handleClosePopupPrivacy = () => {
        setPopupVisiblePrivacy(false);
    };

    const handlePrivacyLinkClickCovid = () => {
        setPopupVisibleCovid(true);
    };

    const handleClosePopupCovid = () => {
        setPopupVisibleCovid(false);
    };
    const handleCheckboxChangeB = (event) => {
        setIsCheckedB(event.target.checked);
    };
    const handleCheckboxChangeP = (event) => {
        setIsCheckedP(event.target.checked);
    };
    const handleCheckboxChangeC = (event) => {
        setIsCheckedC(event.target.checked);
    };

    //acknowladge feature
    const [entity, setEntity] = useState([]); // Properly initialized as an empty array
    const [ackChecklist, setAckChecklist] = useState({});

    const [detailsValid, setDetailsValid] = useState(false); // controls Acknowledge tab enable
    const [openVideoModal, setOpenVideoModal] = useState(false);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [passACKData, setPassACKData] = useState('')
    const empId = localStorage.getItem('employeeId')
    const [pdfUrl, setPdfUrl] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [openPdfModal, setOpenPdfModal] = useState(false);
    const [agreedRows, setAgreedRows] = useState({});
    const [ndaDocumentFileName, setNdaDocumentFileName] = useState("")
    const [ndaDocumnet, setNdaDocument] = useState("")

    useEffect(() => {
        const fetchAppointmentDataeempEntity = async () => {
            if (!data?.entityId) {
                toast.error("Entity ID is missing");
                return;
            }

            try {
                const responseEntity = await axios.get(`/Entity/GetEntityByID/${data?.entityId}`)
                const selectedEntity = responseEntity?.data

                // If you want to keep it in state for modal usage:
                setEntity(responseEntity?.data);
                // Dynamically build the checklist based on what exists in the entity
                const initialChecklist = {};

                if (selectedEntity?.uploadTrainingVideos && selectedEntity?.trainingVideosLink)
                    initialChecklist.training = false;

                if (selectedEntity?.uploadSafetyGuidelinesDocuments && selectedEntity?.safetyGuidelines?.safetyGuidelinesDocumentLink)
                    initialChecklist.safetyDoc = false;

                if (selectedEntity?.uploadSafetyGuidelinesDocuments && selectedEntity?.safetyGuidelines?.safetyGuidelinesVideoLink)
                    initialChecklist.safetyVideo = false;

                if (selectedEntity?.ndaDocument)
                    initialChecklist.ndaDoc = false;

                // Set it in state
                setAckChecklist(initialChecklist);
            } catch (error) {
                console.error('Error fetching appointment data:', error);
            }
        };
        fetchAppointmentDataeempEntity();
    }, [data])

    return (
        <Container>
            <Header>
                <Heading>Group Check-In Form</Heading>
                <ButtonGroup>
                    {(activeTab === "details" || activeTab === "additional") && (<ResetButton onClick={handleReset}>Reset</ResetButton>)}
                    {activeTab === "acknowledge" && (<ResetButton onClick={handleResetAcknowledgement}>Reset</ResetButton>)}

                    {activeTab === "details" && <SubmitButton onClick={() => setActiveTab('additional')}>Next</SubmitButton>}
                    {activeTab === "additional" && <SubmitButton onClick={handleNext}>Next</SubmitButton>}


                    {activeTab === "acknowledge" && (
                        <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
                    )}
                </ButtonGroup>
            </Header>
            <Tabs>
                <Tab active={activeTab === 'details'} onClick={() => setActiveTab('details')}>
                    Details
                </Tab>
                <Tab active={activeTab === 'additional'} onClick={() => setActiveTab('additional')}>
                    Additional
                </Tab>
                <Tab
                    active={activeTab === "acknowledge"}
                    disabled={!detailsValid} // disable until details are valid
                    onClick={() => setActiveTab("acknowledge")}
                >
                    Acknowledgement
                </Tab>
            </Tabs>
            <TabContent active={activeTab === 'details'}>
                <CardContainer>
                    <Card>
                        <FormGroup>
                            <Label>
                                Visitor Type
                                <Asterisk> *</Asterisk>
                            </Label>
                            <Select
                                name="selectedVisitorTypeId"
                                value={formData.selectedVisitorTypeId}
                                onChange={handleChange}
                                disabled={formData.selectedVisitorTypeId ? true : false}
                            >
                                <option value="">Select type</option>
                                {visitorTypes.map((type) => (
                                    <option key={type.id} value={type.id}>{type.visitorTypeDesc}</option>
                                ))}
                            </Select>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Visitor Company{fieldData.visitorCompanyField && <Asterisk> *</Asterisk>}
                            </Label>
                            <Input
                                type="text"
                                name="company"
                                placeholder="Enter Company"
                                value={formData.company}
                                onChange={handleInputChange}
                                disabled={fieldData.visitorCompanyField}

                            />
                        </FormGroup>
                        {/* <FormGroup>
                            <Label>
                                Group Leader Name<Asterisk> *</Asterisk>
                            </Label>
                            <Input
                                type="text"
                                name="groupLeaderName"
                                value={formData.groupLeaderName}
                                onChange={handleInputChange}
                                placeholder="Enter Group Leader Name"
                                style={{
                                    borderBottomColor: formErrors.groupLeaderName ? 'red' : '#2b3497',
                                }}
                                disabled={formData.groupLeaderName ? true : false}
                            />
                        </FormGroup> */}
                        <FormRow>
                            <FormGroup>
                                <Label>
                                    First Name
                                    {fieldData?.visitorNameField && <Asterisk> *</Asterisk>}
                                </Label>
                                <Input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleInputChange}
                                    placeholder="Enter First Name"
                                    disabled={fieldData?.visitorNameField}
                                />

                            </FormGroup>

                            <FormGroup>
                                <Label>Middle Name</Label>
                                <Input
                                    type="text"
                                    name="middleName"
                                    value={formData.middleName}
                                    onChange={handleInputChange}
                                    placeholder="Enter Middle Name (Optional)"
                                    style={{ borderColor: '#2B3497' }}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label>
                                    Last Name
                                    {fieldData?.visitorNameField && <Asterisk> *</Asterisk>}
                                </Label>
                                <Input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleInputChange}
                                    placeholder="Enter Last Name"
                                    disabled={fieldData?.visitorNameField}
                                />

                            </FormGroup>
                        </FormRow>
                        <FormGroup>
                            <Label>
                                Visitor Email{fieldData?.visitorEmailField && <Asterisk> *</Asterisk>}

                            </Label>
                            <Input
                                type="email"
                                name="visitorEmail"
                                value={formData.visitorEmail}
                                placeholder="Enter Email"
                                onChange={handleInputChange}
                                style={{
                                    borderBottomColor: formErrors.visitorEmail ? 'red' : '#2b3497',
                                }}
                                disabled={fieldData?.visitorEmailField}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Gender
                                {fieldData?.genderField && <Asterisk> *</Asterisk>}
                            </Label>
                            <Select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                disabled={true}
                            >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="other">Other</option>
                            </Select>
                            {formErrors.gender && (
                                <span style={{ color: 'red', fontSize: '12px' }}>Please select a gender</span>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Nationality
                                {fieldData?.nationalityField && <Asterisk> *</Asterisk>}
                            </Label>
                            <Input
                                type="text"
                                name="nationality"
                                value={formData.nationality}
                                onChange={handleInputChange}
                                placeholder="Enter Last Name"
                                disabled={true}
                            />

                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Visitor Mobile{fieldData?.visitorMobileField && <Asterisk> *</Asterisk>}
                            </Label>
                            <Input
                                type="tel"
                                name="visitorMobile"
                                value={formData.visitorMobile}
                                placeholder="Enter Mobile number"
                                maxLength="15"
                                // onInput={(e) => {
                                //     // Remove non-numeric characters
                                //     e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                // }}
                                onChange={handleInputChange}
                                style={{
                                    borderBottomColor: formErrors.visitorMobile ? 'red' : '#2b3497',
                                }}
                                disabled={true}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Location
                                {fieldData?.locationField && <Asterisk> *</Asterisk>}
                            </Label>
                            <Select
                                name="meetingvenue"
                                value={formData.meetingVenue}
                                onChange={handleChange}
                                disabled={true}
                            >
                                <option value="">Select Location</option>
                                {meetingvenues.map((type) => (
                                    <option key={type.locationName} value={type.locationName}>
                                        {type.locationName}
                                    </option>
                                ))}
                            </Select>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Gate
                                {fieldData?.gateField && <Asterisk> *</Asterisk>}
                            </Label>
                            <Select
                                name="gate"
                                value={selectedGate ? selectedGate.id : ''}
                                onChange={handleGateChange}
                            >
                                <option value="">Select Gate</option>
                                {gates.map((gate) => (
                                    <option key={gate.id} value={gate.id}>
                                        {gate.name}
                                    </option>
                                ))}
                            </Select>
                            {formErrors.gate && (
                                <span style={{ color: 'red', fontSize: '12px' }}>Please select a gate</span>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Area
                                {fieldData?.areaField && <Asterisk> *</Asterisk>}
                            </Label>
                            <Select
                                name="building"
                                value={formData.building}
                                onChange={handleChange}
                            >
                                <option value="">Select Area</option>
                                {Array.isArray(buildings) &&
                                    buildings.map((building) => (
                                        <option key={building.id} value={building.id}>
                                            {building.name}
                                        </option>
                                    ))}
                            </Select>
                            {formErrors.building && (
                                <span style={{ color: "red", fontSize: "12px" }}>
                                    Please select a building
                                </span>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Purpose{fieldData?.purpose && <Asterisk> *</Asterisk>}
                            </Label>
                            <Input
                                type="text"
                                name="assets"
                                value={formData.purpose}
                                placeholder="Enter purpose"
                                onChange={handleInputChange}
                                disabled={formData.purpose ? true : false}

                            />
                            {formErrors.purpose && (
                                <span style={{ color: 'red', fontSize: '12px' }}>      {formErrors.purpose}</span>
                            )}
                        </FormGroup>
                    </Card>
                    <Card>
                        <FormGroup>
                            <Label>
                                Meeting From{fieldData?.meetingOnField && <Asterisk> *</Asterisk>}
                            </Label>
                            <StyledDatePicker
                                selected={formData.meetingFrom}
                                onChange={(date) =>
                                    setFormData((prevData) => ({ ...prevData, meetingFrom: date }))
                                }
                                showTimeSelect
                                dateFormat="Pp"
                                disabled={formData.meetingFrom ? true : false}

                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Meeting To{fieldData?.meetingToField && <Asterisk> *</Asterisk>}
                            </Label>
                            <StyledDatePicker
                                selected={formData.meetingTo}
                                onChange={(date) =>
                                    setFormData((prevData) => ({ ...prevData, meetingTo: date }))
                                }
                                showTimeSelect
                                dateFormat="Pp"
                                disabled={formData.meetingTo ? true : false}
                            />
                        </FormGroup>
                        <AdditionalInputContainerN>
                            <CheckboxContainer>
                                <CheckboxLabel>All Day</CheckboxLabel>
                                <Checkbox type="checkbox" checked={isAllDayChecked} disabled={true} onChange={handleAllDayCheckboxChange} />
                            </CheckboxContainer>
                        </AdditionalInputContainerN>


                        <FormGroup>
                            <Label>
                                Id Proof Type
                            </Label>{fieldData?.idProofTypeField && <Asterisk> *</Asterisk>}
                            <Select
                                name="selectedIdProofTypeId"
                                value={formData.selectedIdProofTypeId}
                                onChange={handleChange}
                                disabled={true}
                            >
                                <option value="">Select type</option>
                                {idProofTypes.map((type) => (
                                    <option key={type.id} value={type.id}>{type.idProofDescription}</option>
                                ))}
                            </Select>
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Id Proof Number
                            </Label>{fieldData?.idProofNumberField && <Asterisk> *</Asterisk>}
                            <Input
                                type="text"
                                name="idProofNo"
                                maxLength={4}
                                placeholder="Enter Id Proof Number"
                                value={formData.idProofNo}
                                onChange={(e) => {
                                    const regex = /^[a-zA-Z0-9]*$/; // Allows only alphanumeric characters
                                    if (regex.test(e.target.value)) {
                                        handleInputChange(e); // Call the original handler if valid
                                    }
                                }}
                                disabled={true}

                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Transport Vendor Document
                            </Label>

                            <FileUploadContainer>
                                <CustomFileButton onClick={() => document.getElementById("transportVendorFileInput").click()}>
                                    Choose File
                                </CustomFileButton>

                                <FileNameInput
                                    type="text"
                                    value={transportVendorFileName || ""}
                                    placeholder="No file chosen"
                                    readOnly
                                />

                                <HiddenFileInput
                                    id="transportVendorFileInput"
                                    type="file"
                                    accept=".pdf,.doc,.docx"
                                    onChange={async (e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setTransportVendorFileName(file.name);

                                            try {
                                                const base64String = await fileToBase64(file);
                                                setTransportVendorFileBase64(base64String); // <-- raw base64 only
                                            } catch (err) {
                                                console.error("File conversion error:", err);
                                            }
                                        }
                                    }}
                                />
                            </FileUploadContainer>
                        </FormGroup>

                        <FormGroup>
                            <Label>
                                Assets{isCheckedB && (
                                    <Asterisk> *</Asterisk>
                                )}
                            </Label>
                            <Input
                                type="text"
                                name="assets"
                                value={formData.assets}
                                placeholder="Enter Assets count"
                                onChange={handleInputChange}
                            />
                            {formErrors.assets && (
                                <span style={{ color: 'red', fontSize: '12px' }}>      {formErrors.assets}</span>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Remarks{isCheckedB && (
                                    <Asterisk> *</Asterisk>
                                )}
                            </Label>
                            <Input
                                type="text"
                                name="remarks"
                                placeholder="Enter Remarks"
                                value={formData.remarks}
                                onChange={handleInputChange}
                            />
                            {formErrors.remarks && (
                                <span style={{ color: 'red', fontSize: '12px' }}>      {formErrors.remarks}</span>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label>
                                Vehicle No
                            </Label>
                            <Input
                                type="text"
                                name="vehicleno"
                                placeholder="Enter Vehicle No"
                                value={formData.vehicleno}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                    </Card>
                    <ProfileCard>
                        <VisitorPhotoHeading>Visitor Photo</VisitorPhotoHeading>
                        <ProfileText>(Only JPEG and PNG Images)</ProfileText>
                        <Circle>
                            <WebcamContainer>
                                {isCameraOn && (
                                    <Webcam
                                        audio={false}
                                        ref={webcamRef}
                                        screenshotFormat="image/png"
                                        width="100%"
                                        height="100%"
                                        videoConstraints={{
                                            width: 200,
                                            height: 200,
                                            facingMode: 'user',
                                        }}
                                    />
                                )}
                                {!isCameraOn && profileImage && (
                                    <img
                                        src={profileImage}
                                        alt="Profile"
                                        style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                                    />
                                )}
                                {!isCameraOn && !profileImage && (
                                    <ProfileIcon>
                                        <User size={40} />
                                    </ProfileIcon>
                                )}
                            </WebcamContainer>
                        </Circle>
                        <ButtonRow>
                            <PhotoButton onClick={handleCapture}>
                                {buttonLabel}
                            </PhotoButton>
                        </ButtonRow>
                        <ButtonRow>
                            <ActionButton onChange={handleImageUpload}>
                                <label htmlFor="upload-button" style={{ cursor: 'pointer' }}>
                                    Upload image
                                </label>
                            </ActionButton>
                        </ButtonRow>
                        <input
                            id="upload-button"
                            type="file"
                            accept="image/png, image/jpeg"
                            style={{ display: 'none' }}
                            onChange={handleImageUpload}
                        />
                        <CheckboxRowContainer>
                            <CheckboxContainer>
                                <input type="checkbox" checked={isCheckedB} onChange={handleCheckboxChangeB} />
                                <span>
                                    <PrivacyLink>Print-Baggage Tag</PrivacyLink>
                                </span>
                            </CheckboxContainer>
                            <CheckboxContainer>
                                <input type="checkbox" checked={isCheckedP} onChange={handleCheckboxChangeP} />
                                <span>
                                    <PrivacyLink onClick={handlePrivacyLinkClickPrivacy}>Privacy Policy<span style={{ color: 'red' }}> *</span></PrivacyLink>
                                </span>
                            </CheckboxContainer>
                            <CheckboxContainer>
                                <input type="checkbox" checked={isCheckedC} onChange={handleCheckboxChangeC} />
                                <span>
                                    <PrivacyLink onClick={handlePrivacyLinkClickCovid}>COVID Fitness<span style={{ color: 'red' }}> *</span></PrivacyLink>
                                </span>
                            </CheckboxContainer>
                        </CheckboxRowContainer>

                    </ProfileCard>
                </CardContainer>
            </TabContent>
            <TabContent active={activeTab === 'additional'}>
                <CardContainer>
                    <Card>
                        <CheckboxContainer>
                            <CheckboxLabel>Repeat Visit</CheckboxLabel>
                            <Checkbox disabled={true} type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
                        </CheckboxContainer>

                        <HeaderN >Scheduler</HeaderN>

                        <DropdownContainer>
                            <DropdownLabel>Recurrence Pattern:</DropdownLabel>
                            <StyledDropdown disabled={true} value={recurrencePattern} onChange={handleDropdownChange} >
                                <option value="" disabled>Select pattern</option>
                                <option value="1">Daily</option>
                                <option value="2">Weekly</option>
                                <option value="3">Monthly</option>
                            </StyledDropdown>
                        </DropdownContainer>

                        {/* Daily input for selecting the day */}
                        {/* <InputContainer show={recurrencePattern === '1'}>
                            <SpinnerInputLabel>Select Day:</SpinnerInputLabel>
                            <SpinnerInput disabled={true} type="number" min="1" max="31" value={selectedDay} onChange={handleDayChange} />
                        </InputContainer> */}

                        {/* Weekly dropdown for selecting the weekday */}
                        <InputContainer show={recurrencePattern === '2'}>
                            <DropdownLabel>Select Weekdays:</DropdownLabel>
                            <CheckboxContainernew>
                                {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day, index) => (
                                    <CheckboxLabelnew key={index}>
                                        <Checkbox disabled={true}
                                            type="checkbox"
                                            checked={Array.isArray(selectedWeekday) && selectedWeekday.includes(index + 1)} // Check if weekday is in the selected list
                                            onChange={() => handleWeekdayCheckboxChange(index + 1)}
                                        />
                                        {day}
                                    </CheckboxLabelnew>
                                ))}
                            </CheckboxContainernew>
                        </InputContainer>

                        {/* Monthly dropdown for selecting the month */}
                        <InputContainer show={recurrencePattern === '3'}>
                            <DropdownLabel>Select Months:</DropdownLabel>
                            <CheckboxContainernew>
                                {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month, index) => (
                                    <CheckboxLabelnew key={index}>
                                        <Checkbox
                                            disabled={true}
                                            type="checkbox"
                                            checked={selectedMonth.includes(index + 1)} // Ensure selectedMonth is correctly checked
                                            onChange={() => handleMonthCheckboxChange(index + 1)}
                                        />
                                        {month}
                                    </CheckboxLabelnew>
                                ))}
                            </CheckboxContainernew>
                        </InputContainer>

                        {/* All Day checkbox and Recur Every input */}
                        <InputContainer show={recurrencePattern === '2' || recurrencePattern === '3' || recurrencePattern === '1'}>
                            <SpinnerInputLabel>Recur Every:</SpinnerInputLabel>
                            <RecurrenceInput disabled={true} type="number" min="1" value={recurEvery} onChange={handleRecurEveryChange} />
                        </InputContainer>

                        {/* <AdditionalInputContainer show={recurrencePattern === '2' || recurrencePattern === '3'}>
                            <CheckboxContainer>
                                <CheckboxLabel>All Day</CheckboxLabel>
                                <Checkbox disabled={true} type="checkbox" checked={isAllDayChecked} onChange={handleAllDayCheckboxChange} />
                            </CheckboxContainer>
                        </AdditionalInputContainer> */}

                        {/* New Section for Selected Values */}
                    </Card>
                    <Card>
                        <SwitchContainer>
                            <SwitchRow>
                                <SwitchLabel>Assistance Required</SwitchLabel>
                                <Switch isOn={isAssistanceRequired} onClick={!disabled ? toggleAssistanceRequired : undefined}>
                                    <SwitchSlider isOn={isAssistanceRequired} />
                                    <SwitchText isOn={isAssistanceRequired}>{isAssistanceRequired ? 'Yes' : 'No'}</SwitchText>
                                </Switch>
                            </SwitchRow>

                            <SwitchRow>
                                <SwitchLabel>Service Provider Access</SwitchLabel>
                                <Switch isOn={isServiceProviderAccess} onClick={!disabled ? toggleServiceProviderAccess : undefined}>
                                    <SwitchSlider isOn={isServiceProviderAccess} />
                                    <SwitchText isOn={isServiceProviderAccess}>{isServiceProviderAccess ? 'Yes' : 'No'}</SwitchText>
                                </Switch>
                            </SwitchRow>

                            <SwitchRow>
                                <SwitchLabel>WiFi Required</SwitchLabel>
                                <Switch isOn={isWiFiRequired} onClick={!disabled ? toggleWiFiRequired : undefined}>
                                    <SwitchSlider isOn={isWiFiRequired} />
                                    <SwitchText isOn={isWiFiRequired}>{isWiFiRequired ? 'Yes' : 'No'}</SwitchText>
                                </Switch>
                            </SwitchRow>

                            <SwitchRow>
                                <SwitchLabel>Escort Required</SwitchLabel>
                                <Switch isOn={isEscortRequired} onClick={!disabled ? toggleEscortRequired : undefined}>
                                    <SwitchSlider isOn={isEscortRequired} />
                                    <SwitchText isOn={isEscortRequired}>{isEscortRequired ? 'Yes' : 'No'}</SwitchText>
                                </Switch>
                            </SwitchRow>
                            <SwitchRow>
                                <SwitchLabel> Additional Notification</SwitchLabel>
                                <Switch isOn={isadditionalNotify} onClick={!disabled ? toggleadditionalNotifyRequired : undefined}>
                                    <SwitchSlider isOn={isadditionalNotify} />
                                    <SwitchText isOn={isadditionalNotify}>{isadditionalNotify ? 'Yes' : 'No'}</SwitchText>
                                </Switch>
                            </SwitchRow>
                        </SwitchContainer>
                        <FormGroup style={{ 'marginTop': '20px' }}>
                            <Label>
                                Card Number
                            </Label>
                            <Input
                                type="text"
                                name="CardNumber"
                                value={formData.CardNumber}
                                placeholder="Enter card number"
                                maxLength="9"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only numeric input
                                    if (/^\d*$/.test(value)) {
                                        handleInputChange(e); // Update form data only if the input is valid
                                    }
                                }} style={{
                                    borderBottomColor: formErrors.CardNumber ? 'red' : '#2b3497',
                                }}
                            />
                        </FormGroup>
                        <InputFieldContainer>
                            <InputLabelN>
                                Notify to:
                                {isadditionalNotify && <Asterisk> *</Asterisk>}
                            </InputLabelN>
                            <ChipContainer>
                                {selectedEmails.map((email, index) => (
                                    <Chip key={index}>
                                        {email}
                                        {isadditionalNotify && (
                                            <RemoveChipButton style={{ pointerEvents: 'none' }} onClick={() => handleChipRemove(email)}>
                                                &times;
                                            </RemoveChipButton>
                                        )}
                                    </Chip>
                                ))}
                                <InputField
                                    value={inputValue}
                                    onChange={handleInputChangeE}
                                    onKeyDown={handleKeyDown}
                                    disabled={true}
                                    placeholder="Enter email ID"
                                />
                            </ChipContainer>
                            {filteredSuggestions.length > 0 && (
                                <SuggestionBox>
                                    {filteredSuggestions.map((emp) => (
                                        <SuggestionItem
                                            key={emp.id}
                                        >
                                            {emp.employeeMailId} - {emp.employeeName}
                                        </SuggestionItem>
                                    ))}
                                </SuggestionBox>
                            )}
                        </InputFieldContainer>

                        {/* Additional Input Fields */}
                        <InputFieldContainer>
                            <InputLabel>Message to Visitors:</InputLabel>
                            <StyledTextArea
                                value={additionalMessage}
                                onChange={handleAdditionalMessageChange}
                                placeholder="Enter message here"
                                rows={recurrencePattern === '1' ? 3 : 6}
                                disabled={true}  // Adjust as needed for the number of lines shown by default
                            />
                        </InputFieldContainer>

                        <InputFieldContainer>
                            <InputLabel>Check-In Instructions:</InputLabel>
                            <StyledTextArea
                                value={checkInInstructions}
                                onChange={handleCheckInInstructionsChange}
                                placeholder="Enter instructions here"
                                rows={recurrencePattern === '1' ? 3 : 6}
                                disabled={true}   // Adjust as needed for the number of lines shown by default
                            />
                        </InputFieldContainer>

                    </Card>



                </CardContainer>
            </TabContent>

            <TabContent active={activeTab === 'acknowledge'}>
                <CardContainer>
                    <Card>
                        {(entity?.uploadTrainingVideos && entity?.trainingVideosLink) ||
                            (
                                entity?.uploadSafetyGuidelinesDocuments &&
                                (entity?.safetyGuidelines?.safetyGuidelinesDocumentLink ||
                                    entity?.safetyGuidelines?.safetyGuidelinesVideoLink)
                            ) ||
                            entity?.ndaDocument ? <>
                            {/* Training Videos */}
                            {entity?.uploadTrainingVideos && entity?.trainingVideosLink && (
                                <AckItem>
                                    {/* Checkbox only controls state */}
                                    <input
                                        type="checkbox"
                                        id="training"
                                        checked={ackChecklist?.training || false}
                                        onChange={(e) =>
                                            setAckChecklist({
                                                ...ackChecklist,
                                                training: e.target.checked,
                                            })
                                        }
                                    />

                                    <AckText>
                                        I acknowledge I have watched the{" "}
                                        <span
                                            style={{
                                                color: "#293495",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault(); // prevent checkbox toggle when clicking link
                                                setVideoUrl(entity.trainingVideosLink);
                                                setOpenVideoModal(true);
                                            }}
                                        >
                                            Training Video
                                        </span>
                                    </AckText>
                                </AckItem>

                            )}

                            {/* Safety Guidelines Document */}
                            {entity?.uploadSafetyGuidelinesDocuments &&
                                entity?.safetyGuidelines?.safetyGuidelinesDocumentLink && (
                                    <AckItem htmlFor="safetyDoc">
                                        <input
                                            type="checkbox"
                                            id="safetyDoc"
                                            checked={ackChecklist?.safetyDoc || false}
                                            onChange={(e) =>
                                                setAckChecklist({
                                                    ...ackChecklist,
                                                    safetyDoc: e.target.checked,
                                                })
                                            }
                                        />
                                        <AckText>
                                            I acknowledge I have read the{" "}
                                            <span
                                                style={{
                                                    color: "#293495",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    setShowPdfModal(true)
                                                }}
                                                href={entity.safetyGuidelines.safetyGuidelinesDocumentLink}
                                                target="_self"
                                                rel="noopener noreferrer"
                                            >
                                                Safety Guidelines Document
                                            </span>
                                        </AckText>
                                    </AckItem>
                                )}

                            {/* Safety Guidelines Video */}
                            {entity?.uploadSafetyGuidelinesDocuments &&
                                entity?.safetyGuidelines?.safetyGuidelinesVideoLink && (
                                    <AckItem>
                                        {/* Checkbox only controls state */}
                                        <input
                                            type="checkbox"
                                            id="safetyVideo"
                                            checked={ackChecklist.safetyVideo || false}
                                            onChange={(e) =>
                                                setAckChecklist({
                                                    ...ackChecklist,
                                                    safetyVideo: e.target.checked,
                                                })
                                            }
                                        />

                                        <AckText>
                                            I acknowledge I have watched the{" "}
                                            <span
                                                style={{
                                                    color: "#293495",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault(); // don't let it trigger link behavior
                                                    setVideoUrl(entity?.safetyGuidelines?.safetyGuidelinesVideoLink);
                                                    setOpenVideoModal(true);
                                                }}
                                            >
                                                Safety Guidelines Video
                                            </span>
                                        </AckText>
                                    </AckItem>
                                )}
                            {entity?.ndaDocument && (
                                <AckItem>
                                    <input
                                        type="checkbox"
                                        id="ndaDoc"
                                        checked={ackChecklist.ndaDoc || false}
                                        style={{ cursor: 'not-allowed' }}
                                    // disabled
                                    // onChange={(e) =>
                                    //     setAckChecklist({
                                    //         ...ackChecklist,
                                    //         ndaDoc: e.target.checked,
                                    //     })
                                    // }
                                    />
                                    <AckText>
                                        I acknowledge I have read the{" "}
                                        <span
                                            style={{
                                                color: "#293495",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                            }}
                                            onClick={async (e) => {
                                                e.preventDefault();
                                                try {
                                                    const requestData = {
                                                        idProofNumber: formData?.idProofNo,
                                                        hostID: parseInt(empId, 10),
                                                        visitorName: formData?.firstName + (formData?.middleName != null ? " " + formData.middleName : "") + " " + formData?.lastName + " + G",
                                                        visitorMobile: formData?.visitorMobile,
                                                        visitorCompany: formData?.company,
                                                        nationalityCode: data?.nationalityCode,
                                                        ndadDocumentToken: "",
                                                        iAccpect: true,
                                                        checkInDateTime: new Date(),
                                                        VisitorType: String(formData?.selectedVisitorTypeId),
                                                    };

                                                    const response = await axios.post(
                                                        "/Entity/GetNDADocumentByVisitorDetails",
                                                        [requestData]
                                                    );

                                                    if (response.data && response.data.length > 0) {
                                                        const ndaPath = response.data[0].NDADocumentPath;

                                                        const fileResponse = await axios.get(
                                                            `/document/Documentdownload?token=${encodeURIComponent(
                                                                ndaPath
                                                            )}`,
                                                            { responseType: "blob" }
                                                        );

                                                        const pdfBlobUrl = window.URL.createObjectURL(
                                                            new Blob([fileResponse.data], { type: "application/pdf" })
                                                        );

                                                        setPdfUrl(pdfBlobUrl);
                                                        setSelectedRowId(entity.id);
                                                        setOpenPdfModal(true);
                                                    } else {
                                                        toast.error("No NDA document found.");
                                                    }
                                                } catch (error) {
                                                    console.error("Error fetching NDA document:", error);
                                                    toast.error("Failed to fetch the NDA document.");
                                                }
                                            }}
                                        >
                                            NDA Document
                                        </span>
                                    </AckText>
                                </AckItem>
                            )}
                            {ackChecklist.ndaDoc && (
                                <FormGroup>
                                    <Label>
                                        NDA Document
                                    </Label>

                                    <FileUploadContainer>
                                        <CustomFileButton
                                            onClick={() =>
                                                document.getElementById("ndaDocument").click()
                                            }
                                        >
                                            Choose File
                                        </CustomFileButton>

                                        <FileNameInput
                                            type="text"
                                            value={ndaDocumentFileName || ""}
                                            placeholder="No file chosen"
                                            readOnly
                                        />

                                        <HiddenFileInput
                                            id="ndaDocument"
                                            type="file"
                                            accept=".pdf,.doc,.docx"
                                            onChange={async (e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setNdaDocumentFileName(file.name);

                                                    try {
                                                        const base64String = await fileToBase64(file);
                                                        setNdaDocument(base64String); // store base64 string
                                                    } catch (err) {
                                                        console.error("File conversion error:", err);
                                                    }
                                                }
                                            }}
                                        />
                                    </FileUploadContainer>
                                </FormGroup>
                            )}
                        </> : <div
                            style={{
                                textAlign: "center",
                                padding: "2rem",
                                color: "#555",
                                fontSize: "1rem",
                            }}
                        >
                            No acknowledgment materials are available at the moment.
                        </div>
                        }
                    </Card>
                    {openPdfModal && (
                    <PdfModalOverlay>
                        <PdfModalContent>
                        <CloseButtonIcon onClick={() => setOpenPdfModal(false)}>
                            ✖
                        </CloseButtonIcon>
                        <PdfFrame src={pdfUrl} title="NDA Document" />
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
                            <AgreeButton onClick={() => setShowSignatureModal(true)}>
                            I Agree
                            </AgreeButton>
                        </div>
                        </PdfModalContent>
                    </PdfModalOverlay>
                    )}

                    {showSignatureModal && (
                    <PdfModalOverlay>
                        <PdfModalContent style={{ maxWidth: "500px" }}>
                        <CloseButtonIcon onClick={() => {
                            setShowSignatureModal(false);
                            if (sigCanvasRef.current) sigCanvasRef.current.clear();
                        }}>
                            ✖
                        </CloseButtonIcon>

                        <h3 style={{ marginBottom: "10px", color: "#293495" }}>
                            Your Signature
                        </h3>
                        <p style={{ fontSize: "13px", color: "#555", marginBottom: "12px" }}>
                            Signature is mandatory. Please sign below to acknowledge the NDA Document.
                        </p>

                        {/* Signature Canvas */}
                        <div style={{
                            border: "1px solid #2b3497",
                            borderRadius: "8px",
                            overflow: "hidden",
                            marginBottom: "12px",
                            background: "#f9f9f9"
                        }}>
                            <SignatureCanvas
                            ref={sigCanvasRef}
                            penColor="black"
                            canvasProps={{
                                width: 450,
                                height: 200,
                                style: { display: "block" }
                            }}
                            />
                        </div>

                        {/* Clear + Confirm & Agree buttons */}
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <button
                            onClick={() => sigCanvasRef.current?.clear()}
                            style={{
                                padding: "8px 16px",
                                border: "2px solid #293495",
                                borderRadius: "6px",
                                background: "transparent",
                                color: "#293495",
                                cursor: "pointer",
                                fontSize: "14px",
                            }}
                            >
                            Clear
                            </button>

                            <button
                            style={{
                                padding: "8px 16px",
                                background: "#293495",
                                color: "#fff",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: "500",
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = "#1f276f"}
                            onMouseLeave={(e) => e.currentTarget.style.background = "#293495"}
                            onClick={async () => {
                                // ✅ Signature is MANDATORY — block if empty
                                if (!sigCanvasRef.current || sigCanvasRef.current.isEmpty()) {
                                toast.error("Signature is mandatory. Please sign before proceeding.");
                                return;
                                }

                                // Capture base64 signature
                                const signatureDataURL = sigCanvasRef.current
                                .getCanvas()
                                .toDataURL("image/png");

                                console.log("Signature captured:", {
                                visitorName: `${formData.firstName} ${formData.lastName}`,
                                visitorMobile: formData.visitorMobile,
                                signedAt: new Date().toISOString(),
                                signatureBase64: signatureDataURL,
                                });

                                // Close signature modal
                                setShowSignatureModal(false);
                                sigCanvasRef.current.clear();

                                // Call API with NDASignature
                                try {
                                const requestData = {
                                    idProofNumber: formData?.idProofNo,
                                    hostID: parseInt(empId, 10),
                                    visitorName:
                                    formData?.firstName +
                                    (formData?.middleName != null ? " " + formData.middleName : "") +
                                    " " +
                                    formData?.lastName +
                                    " + G",
                                    visitorMobile: formData?.visitorMobile,
                                    visitorCompany: formData?.company,
                                    nationalityCode: data?.nationalityCode,
                                    ndadDocumentToken: "",
                                    iAccpect: true,
                                    checkInDateTime: new Date(),
                                    VisitorType: String(formData?.selectedVisitorTypeId),
                                    NDASignature: signatureDataURL, // ✅ base64 signature
                                };

                                const response = await axios.post(
                                    "/Entity/GetNDADocumentByVisitorDetails",
                                    [requestData]
                                );

                                if (response.data && response.data.length > 0) {
                                    const ndaPath = response.data[0].NDADocumentPath;

                                    const fileResponse = await axios.get(
                                    `/document/Documentdownload?token=${encodeURIComponent(ndaPath)}`,
                                    { responseType: "blob" }
                                    );

                                    const updatedPdfBlobUrl = window.URL.createObjectURL(
                                    new Blob([fileResponse.data], { type: "application/pdf" })
                                    );

                                    // Update PDF, mark agreed, close PDF modal
                                    setPdfUrl(updatedPdfBlobUrl);
                                    setAckChecklist((prev) => ({ ...prev, ndaDoc: true }));
                                    setAgreedRows((prev) => ({ ...prev, [selectedRowId]: true }));
                                    setOpenPdfModal(false);
                                    toast.success("You agreed to the NDA.");
                                } else {
                                    toast.error("No NDA document found.");
                                }
                                } catch (error) {
                                console.error("Error applying signature:", error);
                                toast.error("Failed to apply signature.");
                                }
                            }}
                            >
                            Confirm
                            </button>
                        </div>
                        </PdfModalContent>
                    </PdfModalOverlay>
                    )}

                    {openVideoModal && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                background: "rgba(0,0,0,0.7)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 2000, // ensure above everything
                            }}
                        >
                            <div
                                style={{
                                    position: "relative",
                                    width: "80%",
                                    maxWidth: "900px",
                                    background: "#000",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                }}
                            >
                                {/* Close button */}
                                <button
                                    onClick={() => {
                                        setOpenVideoModal(false);
                                        setVideoUrl(""); // clear video when closing
                                    }}
                                    style={{
                                        position: "absolute",
                                        top: "10px",
                                        right: "10px",
                                        fontSize: "22px",
                                        background: "transparent",
                                        border: "none",
                                        color: "#fff",
                                        cursor: "pointer",
                                        zIndex: 2100,
                                    }}
                                >
                                    ✖
                                </button>

                                {/* Video Player */}
                                {videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be") ? (
                                    <iframe
                                        width="100%"
                                        height="500"
                                        src={
                                            videoUrl.includes("watch?v=")
                                                ? videoUrl.replace("watch?v=", "embed/")
                                                : videoUrl.replace("youtu.be/", "youtube.com/embed/")
                                        }
                                        title="Training Video"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                ) : (
                                    <video width="100%" height="500" controls autoPlay>
                                        <source src={videoUrl} type="video/mp4" />
                                        Your browser does not support HTML5 video.
                                    </video>
                                )}
                            </div>
                        </div>
                    )}

                </CardContainer>
                {showPdfModal &&
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            background: "rgba(0,0,0,0.7)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 2000, // ensure above everything
                            cursor: "pointer"
                        }}
                        onClick={() => setShowPdfModal(false)}
                    >
                        <div
                            style={{
                                position: "relative",
                                width: "80%",
                                maxWidth: "1120px",
                                height: "80%",
                                background: "#000",
                                borderRadius: "10px",
                                overflow: "hidden",
                            }}
                        >
                            <div
                                style={{
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                }}
                            >S
                                <CloseButton onClick={() => setShowPdfModal(false)} >✖</CloseButton>

                            </div>
                            <iframe
                                src={entity?.safetyGuidelines?.safetyGuidelinesDocumentLink}
                                width="100%"
                                height="100%"
                                title="Safety Guidelines"
                            />

                        </div>
                    </div>
                }
                {/* <TableContainer>
                            <StyledTable>
                              <thead>
                                <tr>
                                  <TableHeader>Visitor Name</TableHeader>
                                  <TableHeader>Nationality</TableHeader>
                                  <TableHeader>Mobile</TableHeader>
                                  <TableHeader>Company</TableHeader>
                                  <TableHeader>ID Proof No</TableHeader>
                                  <TableHeader>NDA Document</TableHeader>
                                  <TableHeader>Action</TableHeader>
                                </tr>
                              </thead>
                              <tbody>
                                <TableRow>
                                  <TableCell>
                                    {passACKData.firstName}  {formData.passACKData}
                                  </TableCell>
                                  <TableCell>{passACKData.nationality}</TableCell>
                                  <TableCell>{passACKData.visitorMobile}</TableCell>
                                  <TableCell>{passACKData.company}</TableCell>
                                  <TableCell>{passACKData.idProofNo}</TableCell>
                  
                                  <TableCell>
                                    {entity?.ndaDocument ? (
                                      <span
                                        style={{ color: "#293495", cursor: "pointer", fontWeight: 500 }}
                                        onClick={async () => {
                                          try {
                                            const requestData = {
                                              idProofNumber: passACKData.idProofNo,
                                              hostID: parseInt(empId, 10),
                                              visitorName: passACKData.firstName,
                                              visitorMobile: passACKData.visitorMobile,
                                              visitorCompany: passACKData.company,
                                              nationalityCode: passACKData.nationality,
                                              ndadDocumentToken: entity.ndaDocument,
                                              iAccpect: true,
                                            };
                  
                                            const response = await axios.post(
                                              "/Entity/GetNDADocumentByVisitorDetails",
                                              [requestData]
                                            );
                  
                                            if (response.data && response.data.length > 0) {
                                              const ndaPath = response.data[0].NDADocumentPath;
                  
                                              const fileResponse = await axios.get(
                                                `/document/Documentdownload?token=${encodeURIComponent(ndaPath)}`,
                                                { responseType: "blob" }
                                              );
                  
                                              const pdfBlobUrl = window.URL.createObjectURL(
                                                new Blob([fileResponse.data], { type: "application/pdf" })
                                              );
                  
                                              setPdfUrl(pdfBlobUrl);
                                              setSelectedRowId(entity.id);
                                              setOpenPdfModal(true);
                                            } else {
                                              toast.error("No NDA document found for this visitor.");
                                            }
                                          } catch (error) {
                                            console.error("Error fetching NDA document:", error);
                                            toast.error("Failed to fetch the NDA document. Please try again.");
                                          }
                                        }}
                                      >
                                        <i className="fas fa-eye" style={{ marginRight: "6px" }}></i>
                                        View NDA
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </TableCell>
                  
                                  <TableCell>
                                    <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                                      <input
                                        type="checkbox"
                                        checked={!!agreedRows[entity.id]}
                                        onChange={(e) => {
                                          setAgreedRows(prev => ({
                                            ...prev,
                                            [entity.id]: e.target.checked,
                                          }));
                                        }}
                                      />
                                      I Agree
                                    </label>
                                  </TableCell>
                  
                                </TableRow>
                  
                              </tbody>
                            </StyledTable>
                          </TableContainer> */}

            </TabContent>
            {isPopupVisiblePrivacy && (
                <PopupOverlay>
                    <PopupContent>
                        <h3>Privacy Policy</h3>
                        {entity?.privacyPolicy ? <div> {entity?.privacyPolicy}</div> :
                            <div>
                                <p>
                                    While visiting facilities ("Facilities"), the visitor may have access
                                    to or receive some information that is secret or proprietary to Fidrox
                                    (collectively ‘Company’) concerning their business or technology. The visitor
                                    undertakes to adhere by the rules of this Agreement respecting the confidentiality
                                    of any Confidential Information to which he or she has access or receives.
                                </p>
                                <p>
                                    “Confidential Information”: for purpose of this Agreement shall mean and include, any and all
                                    information in written, electronic, verbal or other form relating directly or indirectly
                                    to the present or potential business, operation or financial condition of or relating including,
                                    but not limited to, information pertaining to pricing, marketing plans or strategy, volumes, services rendered,
                                    customers and suppliers lists, financial or technical or service matters or data, trade secrets,
                                    designs, programming codes, personal or sensitive data of any related parties, intellectual property,
                                    and any information which might reasonably be presumed to be proprietary or confidential in nature and also
                                    includes all information identified by Company as confidential.
                                </p>
                                <p>
                                    I agree that:
                                </p>
                                <ul>
                                    <li>I have access to confidential information, I shall not release, publish, or disclose such information to unauthorized personnel. I shall protect such information and will employ all reasonable efforts to maintain the confidentiality of such information.</li>
                                    <li>I shall immediately notify the Company-security personnel of any suspected or confirmed unauthorized disclosure and/or misuse of confidential information.</li>
                                    <li>I shall not make any sound recordings, take any photographs or make any movies, copies or reproductive images (in any medium) of anything at the facility (ies); Upon Company’s request, I shall promptly return all Confidential Information received from Company together with all copies, or certify in writing that all such Confidential Information and copies thereof have been destroyed.</li>
                                    <li>While entering Company data center, I consent for my personal body and my belongings (baggage, luggage, electronic gadgets, etc.) for security frisking purposes.</li>
                                    <li>Company may collect certain personal information with relation to the purpose of this agreement that is visiting data center(s). I acknowledge it in detail at <a href="https://www.fidrox.com/privacy-policy/" target="_blank">https://www.fidrox.com/privacy-policy/</a>.</li>
                                    <li>This Agreement shall remain in effect until such time as all Confidential Information of Company disclosed hereunder becomes publicly known without my action or inaction.</li>
                                </ul>
                            </div>
                        }
                        <ButtonContainer>
                            <CloseButton onClick={handleClosePopupPrivacy}>Close</CloseButton>
                        </ButtonContainer>
                    </PopupContent>
                </PopupOverlay>
            )}
            {isPopupVisibleCovid && (
                <PopupOverlay>
                    <PopupContent>
                        <h3>Covid Fitness </h3>
                        {entity?.covidFitness ? <p>{entity?.covidFitness} </p> :
                            <p>
                                The basic preventive measures include simple public health measures that are to be followed to reduce the risk of infection with COVID-19. These measures need to be observed by all (employees and visitors) at all times. These include: Physical distancing of at least one meter to be followed at all times. Use of face covers/masks to be mandatory. Practice frequent hand washing (for at least 40-60 seconds) even when hands are not visibly dirty and use of alcohol based hand sanitizers (for at least 20 seconds). Respiratory etiquettes to be strictly followed. This involves strict practice of covering one’s mouth and nose while coughing/sneezing with a tissue/handkerchief/flexed elbow and disposing off used tissues properly. Self-monitoring of health by all and reporting any illness at the earliest.Place the ill person in a room or area where they are isolated from others at the workplace. Provide a mask/face cover till such time he/she is examined by a doctor. Report to concerned central/state health authorities. Helpline 1075 will be immediately informed. A risk assessment will be undertaken by the designated public health authority (district RRT/treating physician) and accordingly further advice shall be made regarding management of case, his/her contacts and need for disinfection. The suspect case if reporting very mild / mild symptoms on assessment by the health authorities would be placed under home isolation, subject to fulfilment of criteria laid down in MoHFW guidelines. Suspect case, if assessed by health authorities as moderate to severe, he/she will follow guidelines as laid down by MoHFW. The rapid response team of the concerned district shall be requisitioned and will undertake the listing of contacts. The necessary actions for contact tracing and disinfection of work place will start once the report of the patient is received as positive. The report will be expedited for this purpose.
                            </p>
                        }
                        <ButtonContainer>
                            <CloseButton onClick={handleClosePopupCovid}>Close</CloseButton>
                        </ButtonContainer>
                    </PopupContent>
                </PopupOverlay>
            )}
            <ToastContainer />

        </Container>
    );
};

export default GroupAppoinmentFormPage;